// extracted by mini-css-extract-plugin
export default {"container":"Products_container__-h-yX","products":"Products_products__NMReL","menu":"Products_menu__r5YRT","list":"Products_list__irc4+","product":"Products_product__FKiES"};